var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1709_14317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.385 9.60001C32.383 9.1471 32.2022 8.7133 31.882 8.39304C31.5617 8.07278 31.1279 7.89199 30.675 7.89001H5.34C4.88578 7.89001 4.45006 8.06993 4.12819 8.3904C3.80631 8.71088 3.62448 9.14581 3.6225 9.60001V11.4225H32.3925L32.385 9.60001Z",
    fill: "#1552DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.61497 26.4001C3.61695 26.8543 3.79878 27.2892 4.12066 27.6097C4.44253 27.9301 4.87826 28.1101 5.33247 28.1101H30.66C31.1142 28.1101 31.5499 27.9301 31.8718 27.6097C32.1937 27.2892 32.3755 26.8543 32.3775 26.4001V15.3676H3.60747L3.61497 26.4001Z",
    fill: "url(#paint0_linear_1709_14317)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.385 11.4225H3.61502V15.3675H32.385V11.4225Z",
    fill: "#FFC522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1425 19.17H23.8725V24.51H30.1425V19.17Z",
    fill: "#FFD767"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1709_14317",
    x1: 17.9925,
    y1: 15.3676,
    x2: 17.9925,
    y2: 28.1101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2666FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C46CC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1709_14317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.3726370aff8e5dd82bd7a57a37433f84.svg";
export { ForwardRef as ReactComponent };